// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__5Y2f-","title":"FrontImage_title__1xwR9"};